import axios from 'axios';
import ApplicationController from '../application_controller.js'
import { isBlank, parseString, formatNumber, secondsToHours } from '../../commons.js';
import State from './state.js';
import * as Choices from 'choices.js'

/*
 * l'id de la task et son timer_state sont dans le dataset de this.element
 * itasks ou tasks est défini dans le dataset et utilisé pour les messages refresh
 * State dispose d'une référence au controlleur filter, initialisée dans la fonction connect() de daily-filter
 */

export default class CfileTasksController extends ApplicationController {

  static targets = [
    "clientSelect", "cfileSelect",
    "duration", "rate", "amount", "timerState",
    "addTimerBlock", "startTimerButton", "timerLanguage", "timerValue"
  ]

  connect() {
    this.klass = this.element.dataset.klass
    if (this.klass == "tasks") {
      setTimeout(this.setup.bind(this), 20)
    }

    if (this.element.dataset.timerState === 'running') {
      this.update_timer();
      this.timer_id = setInterval(() => {
        this.update_timer();
      }, 1000);
    } else {
      this.timer_id = null
    }

    if (this.element.dataset.listenevents === "true") {
      this.evtL1 = this.evtSetClientAndCfile.bind(this)
      document.addEventListener('@daily-task#setClient', this.evtL1, false)
    }
  }

  disconnect() {
    if (this.klass === "tasks" && this.element.querySelector("#client_id") !== null) {
      this.choices.destroy();
      this.choices = null;
    }
    if (this.timer_id) {
      clearInterval(this.timer_id)
    }

    if (this.element.dataset.listenevents === "true") {
      document.removeEventListener('@daily-task#setClient', this.evtL1, false)
    }
  }

  //
  // Créer le select Choice
  // Cette fonction n'est appellée que pour les tasks (pas les itasks)
  //
  setup() {
    let select = this.element.querySelector("#client_id")
    if (select === null) // Pas de select client si pas de formulaire
      return
    this.choices = new Choices(select, {
      silent: true,
      allowHTML: true,
      itemSelectText: "Touche ENTREE pour sélectionner",
      noResultsText: "",
      shouldSort: false,
      searchResultLimit: 20,
      searchFields: ['label'],
      fuseOptions: {
        location: 0,
        threshold: 0,
        distance: 0,
        includeScore: true,
      },
      classNames: {
        containerOuter: 'choices dl_choices__outer',
        containerInner: 'dl_choices__inner',
        list: 'choices__list',
        listSingle: 'dl_choices__list_single',
        listDropdown: 'dl_choices__list--dropdown',
        input: 'dl_choices__input',
        item: 'dl_choices__item'
      },
    })
  }

  setClientAndCfile(e) {
    e.preventDefault
    const elem = e.target
    const event = new CustomEvent("@daily-task#setClient", { detail: { client_id: elem.dataset.clientId, cfile_id: elem.dataset.cfileId }, bubbles: true });
    elem.dispatchEvent(event)
  }

  async evtSetClientAndCfile(e) {
    this.choices.setChoiceByValue([e.detail.client_id])
    // un dispatch sera asynchrone (non pas le dispatch par lui même mais l'exécution de this.client_change)
    // donc pas possible d'utiliser this.clientSelectTarget.dispatchEvent(new Event("change"))
    await this.client_change()
    this.cfileSelectTarget.value = e.detail.cfile_id
    this.cfileSelectTarget.dispatchEvent(new Event("change"))
  }

  refresh_filter_list(which) {
    State.filter_controller.refreshList(which)
  }

  enable_editor() {
    State[`${this.klass}_editor_opened`] = false
  }

  disable_editor() {
    State[`${this.klass}_editor_opened`] = true
  }

  editor_opened() {
    return State[`${this.klass}_editor_opened`] === true
  }

  //
  // Fonctions CRUD
  //

  edit(e) {
    e.preventDefault()

    if (!this.editor_opened()) {
      axios.get(e.target.getAttribute('href')).then(response => {
        this.element.outerHTML = response.data
        this.disable_editor()
      })
    }
  }

  cancel(e) {
    e.preventDefault()

    if (isBlank(this.element.dataset.id)) {
      this.element.innerHTML = ''
    } else {
      axios.get(e.target.getAttribute('href')).then(response => {
        this.element.outerHTML = response.data
        this.enable_editor()
      })
    }
  }

  submit(e) {
    e.preventDefault()

    var form = e.target.closest('form')
    axios({
      method: form.getAttribute('method'),
      url: form.getAttribute('action'),
      data: new FormData(form)
    }).then(response => {
      this.element.outerHTML = response.data
      this.refresh_filter_list(this.klass)
      document.dispatchEvent(new Event('@timer-header#refresh'))
      this.enable_editor()
    }).catch(error => {
      this.alert(error.response.data)
    })
  }

  destroy(e) {
    e.preventDefault()

    this.confirm(e.target.dataset.confirmText, reason => {
      if (reason.confirm) {
        axios.delete(e.target.getAttribute('href')).then(() => {
          this.element.innerHTML = ''
        })
      }
      reason.close_modal()
    })
  }

  update_timer() {
    var current = this.timerValueTarget.dataset.value++
    this.timerValueTarget.innerHTML = secondsToHours(current)
  }

  display_new_timer_block(disp) {
    console.log(disp)
    if (disp) { // Affiche le bloc start timer
      if (this.addTimerBlockTarget.dataset.noTimer === "true") { // Pas la date du jour
        this.startTimerButtonTarget.classList.add('hidden')
      }
      this.addTimerBlockTarget.classList.remove('hidden')
    } else {
      this.addTimerBlockTarget.classList.add('hidden')
    }
  }

  // Sélection d'un client différent, maj de la liste des dossiers (requête JSON)
  async client_change(e) {
    /*let selected_datalist = document.querySelector("#clients_list option[value='" + e.target.value + "']");
    this.cfileSelectTarget.innerHTML = '';
    if (selected_datalist === null)
      return;
    this.clientSelectTarget.value = selected_datalist.dataset.id;
    console.log(selected_datalist.dataset.value);
    */

    this.cfileSelectTarget.innerHTML = '';
    this.cfileSelectTarget.add(new Option('', ''));
    if (this.clientSelectTarget.value) {
      const response = await axios.get(`/daily/tasks/client_cfiles?client_id=${this.clientSelectTarget.value}&user_id=${State.filter_controller.filterUserTarget.value}`)
      for (const d of response.data) {
        let option = new Option(d.name, d.id);
        option.dataset.hourlyrate = d.hourlyrate;
        option.dataset.language = d.language;
        this.cfileSelectTarget.add(option);
      }
      if (this.hasAddTimerBlockTarget) {
        this.display_new_timer_block(false)
      }
    }
  }

  // Sélection d'un dossier différent, maj du language et du hourly_rate
  cfile_change() {
    var selected_cfile = this.cfileSelectTarget.options[this.cfileSelectTarget.selectedIndex]
    this.rateTarget.value = selected_cfile.dataset.hourlyrate
    this.recompute()
    if (this.hasAddTimerBlockTarget) {
      this.timerLanguageTarget.innerHTML = selected_cfile.dataset.language
      this.display_new_timer_block(isBlank(this.element.dataset.id) && !isBlank(selected_cfile.value))
    }
  }

  nature_change(e) {
    var duration = e.target.options[e.target.selectedIndex].dataset.defaultDuration
    if (!isBlank(duration)) {
      this.durationTarget.value = duration
      this.recompute()
    }
  }

  // event keyup des champs duration et hourly_rate
  recompute() {
    var duration = parseString(this.durationTarget.value)
    var rate = parseString(this.rateTarget.value)
    this.amountTarget.value = formatNumber(duration / 60 * rate)
  }

  timer_change(e) {
    e.preventDefault()
    axios.put(e.target.getAttribute('href')).then(() => { // PUT (update) de la tâche ex. /daily/tasks/180?task%5Btimer_state%5D=terminated
      if (e.target.dataset.newTimerState === 'terminated') { // On réouvre le formulaire en édition
        axios.get(`/daily/tasks/${this.element.dataset.id}/edit`)
          .then(response => {
            this.element.outerHTML = response.data
          })
      } else {
        document.dispatchEvent(new Event('@timer-header#refresh'))
        this.refresh_filter_list('all')
      }
    })
  }

  // event click sur le bouton "démarrer chronomètre"
  new_timer_start(e) {
    e.preventDefault()
    this.timerStateTarget.value = 'running'
    this.submit(e) // POST task
  }

}